import { useNavigate, useParams } from 'react-router'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { Container } from '@/components/ui/container'
import { ArrowLeftIcon } from '@/components/ui/icons'
import { FullRejectionDetailPanel } from '@/features/host-review/components/full-rejection-detail'
import { useGetFullRejection } from '@/features/host-review/queries/use-get-full-rejection'
import { routes } from '@/routes'
import { useTranslation } from '@/translations/i18n'

/**
 * One full rejection.
 *
 * Null covers three cases the backend does not distinguish - feature off, no
 * such review, or a review that is not a full rejection - and all three mean
 * the same thing here: there is nothing to show.
 */
export const HostReviewFullRejectionDetail = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { reviewId } = useParams<{ reviewId: string }>()

	const { data: detail, isLoading } = useGetFullRejection(reviewId)

	return (
		<Container className='flex flex-col gap-4 py-6' fullWidth>
			<ButtonLegacy
				className='self-start'
				onClick={() =>
					navigate(routes.HOST_REVIEW_FULL_REJECTIONS.path)
				}
				size='sm'
				type='button'
				variant='tertiary'
			>
				<ArrowLeftIcon />
				{t('host_review:full_rejections.detail.back')}
			</ButtonLegacy>

			{/* A 404 here covers three cases the backend does not distinguish -
			    feature off, no such review, or a review that kept at least one
			    photo - so the copy names them rather than claiming the list is
			    empty, which would be about a different page entirely. */}
			{isLoading || detail ? null : (
				<p className='text-neutral-600 text-sm/5'>
					{t('host_review:full_rejections.detail.not_found')}
				</p>
			)}

			{detail ? <FullRejectionDetailPanel detail={detail} /> : null}
		</Container>
	)
}

HostReviewFullRejectionDetail.displayName = 'HostReviewFullRejectionDetail'
